import { useEffect } from 'react';
import WebsiteLibrary from './WebsiteLibrary';
import { websiteProjects } from './projects';

export function WebsitesPage({ projectSlug }: { projectSlug?: string }) {
  const project = websiteProjects.find(item => item.slug === projectSlug);

  useEffect(() => {
    const previousTitle = document.title;
    const title = project ? `${project.name} Website | CMJ Software` : 'Explore Websites | CMJ Software';
    const description = project?.summary || 'Explore real websites by CMJ Software. Browse distinct page designs, mobile layouts, and dashboard previews, then start a website built around your business.';
    const origin = 'https://moorengineers.ai';
    const canonical = `${origin}/websites${project ? `/${project.slug}` : ''}`;
    const image = `${origin}${(project || websiteProjects[0])?.screens[0]?.src || '/cmj-software-logo.png'}`;
    const metadata: [string, string, string][] = [
      ['meta[name="description"]', 'content', description],
      ['link[rel="canonical"]', 'href', canonical],
      ['meta[property="og:title"]', 'content', title],
      ['meta[property="og:description"]', 'content', description],
      ['meta[property="og:url"]', 'content', canonical],
      ['meta[property="og:image"]', 'content', image],
      ['meta[name="twitter:title"]', 'content', title],
      ['meta[name="twitter:description"]', 'content', description],
      ['meta[name="twitter:image"]', 'content', image],
    ];
    const previousMetadata = metadata.map(([selector, attribute, value]) => {
      const element = document.querySelector(selector);
      const previousValue = element?.getAttribute(attribute);
      element?.setAttribute(attribute, value);
      return { element, attribute, previousValue };
    });
    document.title = title;
    return () => {
      document.title = previousTitle;
      previousMetadata.forEach(({ element, attribute, previousValue }) => {
        if (previousValue != null) element?.setAttribute(attribute, previousValue);
      });
    };
  }, [project]);

  return <WebsiteLibrary projects={websiteProjects} projectSlug={projectSlug} theme="light" basePath="/websites" inquiryHref="/templates#templates-contact" brandHref="/" logoSrc="/cmj-software-logo.png" />;
}
